const regularBookingSearchResult = (state = null, action) => {
  if (action.type === "SET_REGULAR_BOOKING_SEARCH_RESULT") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_REGULAR_BOOKING_SEARCH_RESULT": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default regularBookingSearchResult;
